module.exports = require("../dist/plugins/react");